export default {
  headerContent: {
    title: 'Quick Sigorta İş Yeri Sigortası Hesaplama',
    slogan: "İş Yeri Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'İŞ YERİ SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Quick Sigorta İş Yeri Sigortası',
    description: {
      title: 'Quick Sigorta İş Yeri (Paket) Sigortası Nedir? ',
      content: [
        'İş yeri sigortası işletmelerde oluşabilecek yangın, hırsızlık sel ve su baskını gibi birçok riske karşı koruma sağlamaktadır.',
        'Quick Sigorta iş yeri sigortası işletmede oluşacak risklere karşı işletme sahibini koruyarak yeni yatırımlara olanak sağlar.'
      ]
    },
    subContent: {
      title: 'Quick Sigorta İş Yeri (Paket) Sigortası Teminatları Nedir?',
      content: [
        {
          paragraph:
            "Quick Sigorta teminatları ana ve ek olmak üzere 2'ye ayrılmaktadır.",
          subList: null
        },
        {
          paragraph: '<strong><em><u>Ana teminatlar;</u></em></strong>',
          subList: [
            'Yangın, Yıldırım, İnfilak',
            'Deprem ve Yanardağ Püskürmesi',
            'Sel ve Su Basması',
            'Yer Kayması',
            'Grev, Lokavt, Kargaşalık Halk Hareketleri, Kötü Niyetli Hareketler ve Terör'
          ]
        },
        {
          paragraph: '<strong><em><u>Ek teminatlar;</u></em></strong>',
          subList: [
            'Dahili Su,',
            'Fırtına,',
            'Duman,',
            'Dolu,',
            'Kara ve Hava Taşıtları Çarpması,',
            'Kar Ağırlığı',
            'Hırsızlık',
            'Açıktaki Muhteviyat',
            'Cam Kırılması',
            'Üçüncü Şahıs Mali Sorumluluk',
            'Bina Sabit Kıymet Hırsızlık',
            'İzolasyon Eksikliği',
            'Raf ve Vitrin Devrilmesi',
            'Enkaz Kaldırma Masrafları',
            'Kiracının Malike Sorumluluğu',
            'Malikin Kiracıya Sorumluluğu',
            'Malik ve Kiracının Komşuluk Sorumluluğu',
            'Ferdi Kaza',
            'Hukuksal Koruma',
            'Quick İş Yeri Yardım',
            'Covid Destek Paketi (Acil Tıbbi Yardım Teminatı)'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'İş Yeri Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'İş Yeri Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'İş Yeri Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'İş Yeri Sigortası',
        assurance: 'Zorunlu Temsinatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'İş Yeri Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Quick Sigorta İş Yeri Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
